import { Tooltip } from 'primereact/tooltip';

export default function VehiclePlatformSituation({platform, key}) {

    return (
        <div className="col-md-3" key={key}>
            <div className="card-platform-situation">
                <div className="card-header">{platform.platform}</div>
                <div className="card-body">

                    {platform.platformSections && platform.platformSections.length > 0 ? (

                        platform.platformSections.map((platformSection, index) => (

                            <p className={`card-text card-platform-section ${platform.platform == "ZFLEET" && platformSection.platformSection != "Mantenimiento" ? "hidden" : ""}`} key={index}
                                data-pr-tooltip={`${platformSection.description}`}
                                data-pr-position="left"
                                style={{cursor: 'pointer'}}
                            >
                                <div className={`indicator ${platformSection.active ? 'active' : 'inactive'}`}></div>
                                <span>{platformSection.platformSection}</span>
                                <Tooltip target='.card-platform-section'/>
                            </p>
                        ))
                        
                    ) : (
                        <p>No hay información disponible sobre el estatus de este vehículo en esta plataforma.</p>
                    )}
                </div>
            </div>
        </div>
    );
}